module.exports = __webpack_public_path__ + "img/yahoo@2x.39ac364c.jpg";